import { render } from "./UpdateQtde.vue?vue&type=template&id=11065f1f&scoped=true"
import script from "./UpdateQtde.vue?vue&type=script&lang=js"
export * from "./UpdateQtde.vue?vue&type=script&lang=js"

import "./UpdateQtde.vue?vue&type=style&index=0&id=11065f1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11065f1f"]])

export default __exports__